<script setup>
import {ref} from 'vue'
import CustomMask from "@/components/NewPC/CustomMask.vue";
const CustomMaskRef = ref(null);

const open = () => {
  CustomMaskRef.value.open();
}

defineExpose({
  open
})

</script>

<template>
<custom-mask ref="CustomMaskRef">
  <div class="check_account">
    <img src="@/assets/newPc/tip_close_btn.png" alt="" class="close_icon" @click="open">
    <div class="title">您输入的ID不正确</div>
    <div class="desc">游戏内左上角，点击您的头像，切换到社交名片，查看您的ID</div>
    <img class="tip_img" src="@/assets/newPc/tip_img.png" alt="">
    <button class="close_btn" @click="open">知道了</button>
  </div>
</custom-mask>
</template>

<style scoped lang="scss">
.check_account {
  width: 49.5703125vw;
  height: 25.78125vw;
  background: transparent url("@/assets/newPc/dialog_tips_bg.png") no-repeat center center;
  background-size: 100%;
  padding: 1.2109375vw;
  box-sizing: border-box;
  border-radius: 0.4vw;
  position: relative;

  .title {
    font-size: 1.40625vw;
    color: #FF9120;
    font-family: 'SourceHanSansCN-Bold';
    line-height: 1;
    margin-bottom: 1.171875vw;
    text-align: center;
  }

  .desc {
    font-size: 0.78125vw;
    color: #6B6660;
    font-family: 'SourceHanSansCN-Medium';
    line-height: 1;
    margin-bottom: 0.78125vw;
    text-align: center;
  }

  .tip_img {
    width: 37.8125vw;
    height: 17.421875vw;
    margin: auto;
  }

  .close_icon {
    position: absolute;
    top: 0.859375vw;
    right: 0.9375vw;
    width: 1.6015625vw;
    height: 1.5625vw;
  }

  .close_btn {
    position: absolute;
    bottom: -1.1328125vw;
    left: 20.546875vw;
    width: 8.4765625vw;
    height: 2.265625vw;
    background-color: #FF9F1D;
    border-radius: 1.1328125vw;
    border: none;
    color: #fff;
    font-size: 1.09375vw;
    font-family: 'SourceHanSansCN-Bold';
  }
}
</style>